import { PageHeader } from '@ant-design/pro-layout';
import { Typography } from 'antd';
import { useEffect } from 'react';
import { Link, useMatch, useNavigate, useResolvedPath } from 'react-router-dom';
import { RouteDefinition, VerticalTabs } from '../../../shared/vertical-tabs';
import { SubPageLayout } from '../sub-page-layout';
import { ISConfigFeatureFlagsDetails } from './is-config-feature-flags-details';
import { ISConfigHealthProfession } from './is-config-health-profession';
import { ISConfigReindexSearchCollection } from './is-config-reindex-search-collection';
import { ISConfigStateCountries } from './is-config-state-countries';
import { ISConfigFinanceTools } from './is-config-finance-tools';
import { ISConfigSystemFlags } from './is-config-system-flags';

interface ConfigPage {
  id: string;
  path: string;
  title: string;
}

export const IsConfigPage: React.FC = () => {
  const navigate = useNavigate();
  const currentRoutePath = useResolvedPath('').pathname;
  const currentRouteMatch = useMatch(`${currentRoutePath}`);

  const pages: ConfigPage[] = [
    {
      id: '1',
      path: 'feature-flag',
      title: 'Feature Flags'
    },
    {
      id: '2',
      path: 'countries',
      title: 'Countries'
    },
    {
      id: '3',
      path: 'health-profession',
      title: 'Health Professions'
    },
    {
      id: '4',
      path: 're-indexing',
      title: 'Search Indexes'
    },
    {
      id: '5',
      path: 'finance-tools',
      title: 'Finance Tools'
    },
    {
      id: '6',
      path: 'system-flags',
      title: 'System Flags'
    }
  ];

  const configPageNavigationMenu = pages.map((page) => ({
    key: page.id,
    label: <Link to={page.path}>{page.title}</Link>,
    style: { width: '80%' }
  }));

  const routes: RouteDefinition[] = [
    { id: '1', path: 'feature-flag', element: <ISConfigFeatureFlagsDetails /> },
    { id: '2', path: 'countries', element: <ISConfigStateCountries /> },
    { id: '3', path: 'health-profession', element: <ISConfigHealthProfession /> },
    { id: '4', path: 're-indexing', element: <ISConfigReindexSearchCollection /> },
    { id: '5', path: 'finance-tools', element: <ISConfigFinanceTools /> },
    { id: '6', path: 'system-flags', element: <ISConfigSystemFlags /> }
  ];

  useEffect(() => {
    if (currentRouteMatch) {
      navigate(routes[0].path); // Redirect to 1st menu item
    }
  }, [currentRouteMatch, navigate]);

  return (
    <SubPageLayout header={<PageHeader title={<Typography.Title className="staff-title"> IS Config</Typography.Title>} />}>
      <VerticalTabs routes={routes} menuItems={configPageNavigationMenu} />
    </SubPageLayout>
  );
};
